/* Club EarlyBird Javvy storefront: page behaviours copied verbatim from the artifact (assets/js/pdp.js).
   Buy box and quick add live in cebjv-pdp.js (real cart). */
// Customer video cards: play in place inside the card, with sound (javvycoffee.com PDP pattern).
// Tap again to pause; starting one card pauses the others.
(function () {
  const cards = document.querySelectorAll('button.ugc-card[data-video]');
  cards.forEach((card) => {
    card.addEventListener('click', () => {
      let v = card.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.src = card.dataset.video;
        v.poster = card.querySelector('img').src;
        v.playsInline = true;
        v.addEventListener('play', () => card.classList.add('is-playing'));
        ['pause', 'ended'].forEach((ev) => v.addEventListener(ev, () => card.classList.remove('is-playing')));
        card.querySelector('img').after(v); // under the play icon and caption, so they show again on pause
      }
      if (v.paused) {
        cards.forEach((c) => { const o = c.querySelector('video'); if (o && o !== v) o.pause(); });
        v.play().catch(() => {});
      } else {
        v.pause();
      }
    });
  });
})();

// V2 flavor clips: hero loops play; card clips play on hover, or in view on touch screens.
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.hero-vid').forEach((v) => v.play().catch(() => {}));
  const cards = [...document.querySelectorAll('.hover-vid')];
  if (matchMedia('(hover: hover)').matches) {
    cards.forEach((v) => {
      const card = v.closest('.pcard');
      card.addEventListener('mouseenter', () => v.play().catch(() => {}));
      card.addEventListener('mouseleave', () => { v.pause(); v.currentTime = 0; });
    });
  } else {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      e.target.classList.toggle('on', e.isIntersecting);
      e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause();
    }), { threshold: 0.6 });
    cards.forEach((v) => io.observe(v));
  }
})();

// Home page: tab groups and ritual builder.
(function () {
  document.querySelectorAll('[data-tabs]').forEach((group) => {
    const btns = [...group.querySelectorAll('[role=tab]')];
    const panels = [...document.querySelectorAll('[data-panel-of="' + group.dataset.tabs + '"]')];
    const select = (b, focus) => {
      btns.forEach((x) => { x.setAttribute('aria-selected', x === b); x.tabIndex = x === b ? 0 : -1; });
      panels.forEach((p) => { p.hidden = p.dataset.panel !== b.dataset.target; });
      if (focus) b.focus();
    };
    btns.forEach((b, i) => {
      b.id = 'tab-' + group.dataset.tabs + '-' + b.dataset.target;
      const p = panels.find((x) => x.dataset.panel === b.dataset.target);
      if (p) {
        p.id = b.id + '-panel';
        p.setAttribute('role', 'tabpanel');
        p.setAttribute('aria-labelledby', b.id);
        if (!p.querySelector('a, button, input, select, textarea')) p.tabIndex = 0;
        b.setAttribute('aria-controls', p.id);
      }
      b.tabIndex = b.getAttribute('aria-selected') === 'true' ? 0 : -1;
      b.addEventListener('click', () => select(b));
      b.addEventListener('keydown', (e) => {
        const to = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: btns.length - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault();
        select(btns[(to + btns.length) % btns.length], true);
      });
    });
  });
  document.querySelectorAll('[data-chips]').forEach((group) => {
    const btns = [...group.querySelectorAll('button')];
    btns.forEach((b) => b.addEventListener('click', (e) => {
      btns.forEach((x) => x.setAttribute('aria-pressed', x === b));
      const out = document.querySelector(group.dataset.chips);
      if (!out) return;
      out.setAttribute('aria-live', e.isTrusted ? 'polite' : 'off'); // announce picks, not the autoplay
      const d = JSON.parse(b.dataset.result);
      if (d.tint) out.style.setProperty('--pick-tint', d.tint);
      if (d.c) out.style.setProperty('--pick-c', d.c);
      if (d.imgs) {
        out.querySelector('.bundle-imgs').innerHTML = d.imgs.map((s) => '<img src="' + s + '" alt="">').join('<i aria-hidden="true">+</i>');
      } else {
        out.querySelector('img').src = d.img;
        out.querySelector('img').alt = d.name;
      }
      out.querySelector('[data-name]').textContent = d.name;
      out.querySelector('[data-items]').textContent = d.items;
      const price = out.querySelector('[data-price]');
      if (price) price.textContent = d.price;
      const go = out.querySelector('a');
      go.href = d.href;
      if (b.dataset.add) go.dataset.add = b.dataset.add; else delete go.dataset.add;
    }));
    // Auto-cycle (Build Your Ritual): pauses on hover/focus, stops for good once the visitor clicks.
    if (!('autoplay' in group.dataset) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const box = group.closest('section');
    let paused = false;
    const timer = setInterval(() => {
      if (paused) return;
      const i = btns.findIndex((x) => x.getAttribute('aria-pressed') === 'true');
      btns[(i + 1) % btns.length].click();
    }, 3500);
    box.addEventListener('mouseenter', () => { paused = true; });
    box.addEventListener('mouseleave', () => { paused = false; });
    box.addEventListener('focusin', () => { paused = true; });
    btns.forEach((b) => b.addEventListener('click', (e) => { if (e.isTrusted) clearInterval(timer); }));
    // Touch screens never fire mouseenter: any tap or press inside the section stops the rotation for good.
    box.addEventListener('pointerdown', () => { paused = true; clearInterval(timer); }, { passive: true });
    box.addEventListener('touchstart', () => { paused = true; clearInterval(timer); }, { passive: true });
  });
})();

// "Flavor you crave" benefit tiles pop in as they scroll into view.
(function () {
  const tiles = document.querySelectorAll('.crave-list div');
  if (!tiles.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Visible by default; only hidden ('pre') while waiting to animate in, so a failed observer never hides content.
  const io = new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle('pre', !e.isIntersecting)), { threshold: 0.4 });
  tiles.forEach((t, i) => { t.style.transitionDelay = (i % 6) * 70 + 'ms'; io.observe(t); });
})();

// Hero loops: a visible pause button for every background video (WCAG 2.2.2), even when motion is reduced.
(function () {
  document.querySelectorAll('.hero-vid').forEach((v) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'vid-toggle';
    b.innerHTML = '<svg class="i-pause" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>'
      + '<svg class="i-play" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 5l11 7-11 7z"/></svg>';
    const sync = () => {
      b.dataset.state = v.paused ? 'paused' : 'playing';
      b.setAttribute('aria-label', v.paused ? 'Play background video' : 'Pause background video');
    };
    b.addEventListener('click', () => { if (v.paused) v.play().catch(() => {}); else v.pause(); });
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    v.after(b);
    sync();
  });
})();

// Newsletter: subscribes through Klaviyo on the live store. Anywhere else (this prototype, theme previews)
// it shows the confirmation and sends nothing.
(function () {
  document.querySelectorAll('form[data-klaviyo-list]').forEach((form) => {
    const input = form.querySelector('input[type=email]');
    const msg = form.querySelector('.club-msg');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = input.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        form.dataset.state = 'error';
        input.setAttribute('aria-invalid', 'true');
        msg.textContent = 'Enter a valid email, like name@example.com.';
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      const live = /(^|\.)clubearlybird\.com$/.test(location.hostname);
      form.dataset.state = 'busy';
      try {
        if (live) {
          const r = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + form.dataset.klaviyoCompany, {
            method: 'POST',
            headers: { 'content-type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription',
              attributes: { profile: { data: { type: 'profile', attributes: { email } } }, custom_source: 'Homepage: Join the Club' },
              relationships: { list: { data: { type: 'list', id: form.dataset.klaviyoList } } } } }),
          });
          if (!r.ok) throw new Error(String(r.status));
        }
        form.dataset.state = 'done';
        msg.textContent = live ? 'You’re in. Check your inbox for your 10% off code.'
          : 'You’re in. (Preview only: nothing was sent. On the live store this joins the email list.)';
        input.value = '';
      } catch (err) {
        form.dataset.state = 'error';
        msg.textContent = 'That didn’t go through. Try again in a minute, or email wakeupeasy@clubearlybird.com.';
      }
    });
  });
})();
